var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ tabs__light: _vm.mode === 'light', tabs__dark: _vm.mode === 'dark' }},[_c('ul',{staticClass:"tabs__header"},_vm._l((_vm.tabs),function(tab,index){return _c('li',{key:tab.title,class:{ tab__selected: index == _vm.selectedIndex },on:{"click":function($event){return _vm.selectTab(index)}}},[_vm._v("\n      "+_vm._s(tab.title)+"\n    ")])}),0),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ebfe6afc","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Form/Tabs.vue
// module id = 258
// module chunks = 0